import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { Meta } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/services/canonical.service';
import { MainService } from 'src/app/services/main.service';
import { bank_details, currency, passwordValidator, SharedService } from 'src/app/services/shared.service';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { CaptchaService } from 'src/app/services/captcha.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReferralCodeComponent } from 'src/app/pages/public/referral-code/referral-code.component';
import { LegalDocumentsComponent } from 'src/app/pages/public/legal-documents/legal-documents.component';
import { LegalDocumentsService } from 'src/app/services/legal-documents.service';
import { Email, Name_1 } from 'src/app/shared/regex';
import { PasswordSpaceValidator, PasswordStrengthService } from 'src/app/services/password-strength.service';
import { userInfo as UserInfoType } from 'src/app/services/main.service';
import { LeftLayoutComponent } from '../left-layout/left-layout.component';
import { GoogleSignInComponent } from '../google-sign-in/google-sign-in.component';
import { NgClass, DatePipe } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ConsentCaptureService, ConsentCapture } from 'src/app/services/consent-capture.service';



@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LeftLayoutComponent, GoogleSignInComponent, FormsModule, ReactiveFormsModule, NgClass, NgxMaskDirective, RouterLink, DatePipe]
})
export class RegisterComponent implements OnInit {
  passwordStrengthClass: string = '';
  @ViewChild('consentArea') consentArea?: ElementRef<HTMLElement>;
  consentCapture: ConsentCapture | null = null;
  /** The name the current acceptance was given under; consent is void if it changes. */
  private consentedName = '';
  signUpForm: UntypedFormGroup;
  loaderInterval: any;
  idverification: number = 0;
  identityStatus: string = '';
  bank_details!: bank_details;
  queryParamSubscription: Subscription = new Subscription;
  ip_country_id: string | undefined;
  reachOption: any = [];
  in_app_link = false;
  hidePwd = false;
  currencyList = [];
  public country_data: any;
  public currency_data!: currency;
  validator: number[] = [];
  minLength : boolean = false;
  hasUpperCase: boolean = false;
  hasMaxChar: boolean = false;
  hasNumber : boolean = false;
  hasSpecialChar : boolean = false;
  totalStrength: number = 0;
  showPassTooltip  = false;
  last4Number: string = '';
  countryList = [];
  userProfile: any;
  mask = '(000) 000-0000';
  mobile_arr = [];
  countries = [];
  sub_industrys = [];
  industryList = [];
  new_case: boolean = false;
  counCurData = {
    country_id: 1,
    currency_id: 1
  }
  step = {
    MOBILE_NUMBER: 'MOBILE_NUMBER',
     LOADING:'LOADING',
     COMPLETE_PROFILE: 'COMPLETE_PROFILE',
     COMPLETE:'COMPLETE',
    REGISTER: 'REGISTER',
    VERIFY_OTP: 'VERIFY_OTP'
  };
  selectedStep = '';
  loaderComplete: boolean = false;

  otpForm: UntypedFormGroup;
  otpValueGroup = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
  otp_id = '';
  referral_code = ''
  referralCodeExist = false;
  bsModalRef: BsModalRef | undefined;
  
  countdown: number = 180; // Countdown starts from 30 seconds
  countdownInterval: any;
  public environment= environment;
  passwordStrength: any;
  constructor(private fb: UntypedFormBuilder, private router: Router, private route: ActivatedRoute, public mainService: MainService,
    private metaTagService: Meta, private _captcha: CaptchaService,
    private canonicalService: CanonicalService, private _local: localStorageService,
    private apiSer: ApiService, public _shared: SharedService, private _loader: LoaderService, private modalService: BsModalService,private passwordStrengthService: PasswordStrengthService,
    private _consent: ConsentCaptureService,
    private _legal: LegalDocumentsService,
  ) {
    this.signUpForm = this.fb.group({
      doctor_name: ['', [Validators.required,  Validators.maxLength(30)]],//Validators.pattern(Name_1),
      doctor_email: ['', [Validators.required, Validators.pattern(Email)]],
      doctor_password: ['', [Validators.required, Validators.minLength(8), passwordValidator(), PasswordSpaceValidator.cannotContainSpace]],
      // Set by the legal documents modal once the user accepts. Not
      // required on the form itself — the button must stay clickable so the
      // modal can be opened in the first place.
      TnC: [false],
      doctor_mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
    });
    this.selectedStep = this.step.REGISTER;
    this.otpForm = this.fb.group({
      first: ['', [Validators.required, Validators.maxLength(1)]],
      second: ['', [Validators.required, Validators.maxLength(1)]],
      third: ['', [Validators.required, Validators.maxLength(1)]],
      fourth: ['', [Validators.required, Validators.maxLength(1)]],
      fifth: ['', [Validators.required, Validators.maxLength(1)]],
      sixth: ['', [Validators.required, Validators.maxLength(1)]],
    });
  }

  ngOnInit(): void {
    // Fetch the legal documents up front so the modal opens with the text
    // already in hand rather than a loading pane.
    this._legal.preload();

    this._shared.country_currency_info$.subscribe(data => {
      if (data && data.country) {
        this.country_data = data.country;
        if (data.country['country_phone_format']) {
          this.mask = data.country['country_phone_format'];
        }
      }
      if (data && data.currency && data.currency.length) {
        this.currency_data = data.currency[0];
      }
    });
    if (this.environment.production) {
      this.canonicalService.setCanonicalURL('https://business.financemutual.com/register');
      if (this.metaTagService.getTag('name= "title"')) {
        this.metaTagService.removeTag('name= "title"');
        this.metaTagService.removeTag('name= "description"');
        this.metaTagService.removeTag('name= "robots"');
        this.metaTagService.updateTag({ name: 'title', content: 'Register your Business with Finance Mutual' });
        // tslint:disable-next-line:max-line-length
        this.metaTagService.updateTag({ name: 'description', content: 'Sign up with Finance Mutual to easily manage and grow your business and take advantage of the most popular payment plan features.' });
        this.metaTagService.updateTag({ name: 'robots', content: 'index, follow' });
      } else {
        this.metaTagService.addTags([
          { name: 'title', content: 'Register your Business with Finance Mutual' },
          // tslint:disable-next-line:max-line-length
          { name: 'description', content: 'Sign up with Finance Mutual to easily manage and grow your business and take advantage of the most popular payment plan features.' },
          { name: 'robots', content: 'index, follow' }
        ]);
      }
    }

    const token = this._local.customGetItem('token');

    // if access token is there then redirect to dashboard 
    if (token !== null && token !== undefined) {
      this.mainService.accessTokenLogin()
    }
    // this.getIndustryList();
    if (this.mainService.path_redirect_to) {
      this.router.navigate([], { queryParams: { route_link: this.mainService.path_redirect_to } });
    }
    this.mainService.ip_country_id$.subscribe(data => {
      if (data && data) {
        this.ip_country_id = data;
      }
    });
    this._shared.country_data$.subscribe(data => {
      if (data && data.length) {
        this.country_data = data[0];
        this.counCurData.country_id = data[0]['country_id'];
        this.counCurData.currency_id = data[0]['currency'][0]['currency_id'];
      }
    })

    // get details useragent to check the device
    let details = window.navigator.userAgent;

    /* Creating a regular expression
    containing some mobile devices keywords
    to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details
    it returns boolean value*/
    let isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      console.log("You are using a Mobile Device");
      this.in_app_link = true;
    } else {
      console.log("You are using Desktop");
    }

    this.route.queryParams.subscribe(params => {
      this.referral_code = params['referral_code'] || '';
      this.referralCodeExist = true;
    });
    // Consent is recorded against a named person and the captured screenshot
    // shows that name, so changing it invalidates an acceptance already given.
    this.signUpForm.get('doctor_name')?.valueChanges.subscribe((name: string) => {
      // Compared against the name the consent was given under, not fired on
      // every emission: setValue() from trimming or a re-render emits without
      // the user having changed anything, and resetting there would reopen the
      // documents for someone who has already accepted.
      if (this.signUpForm.controls['TnC'].value &&
          (name ?? '').trim() !== this.consentedName) {
        this.resetConsent();
      }
    });

    this.signUpForm.get('doctor_password')?.valueChanges.subscribe(password => {
      // console.log('New Password:', password);
      // Contains uppercase letters (A-Z)
    if ((/[A-Z]/.test(password)) && (/[a-z]/.test(password))) {
      this.hasUpperCase = true;
    }else{
      this.hasUpperCase = false;
    }

    // Contains numbers (0-9)
    if (/[0-9]/.test(password)) {
      this.hasNumber = true;
    }else{
      this.hasNumber = false;
    }

    // Contains special characters (!@#$%^&*)
    if (/[^A-Za-z0-9]/.test(password)) {
      this.hasSpecialChar = true;
    }else{
        this.hasSpecialChar = false;
      }

    if (password.length >= 8 ) {
      this.hasMaxChar = true;
    }else{
      this.hasMaxChar = false;
    }
    this.totalStrength = (Number(this.hasUpperCase) + Number(this.hasNumber) + Number(this.hasSpecialChar) + Number(this.hasMaxChar))
      this.passwordStrength = this.passwordStrengthService.calculatePasswordStrength(password);
      
      switch (this.passwordStrength) {
        case 'Weak Password':
          this.passwordStrengthClass = 'text-weak';
          break;

        case 'Average Password':
          this.passwordStrengthClass = 'text-average';
          break;

        case 'Good Password':
          this.passwordStrengthClass = 'text-good';
          break;

        case 'Strong Password':
          this.passwordStrengthClass = 'text-strong';
          break;

        default:
          this.passwordStrengthClass = 'text-muted';
      }
    });
  }

  onInput(event: any, currentIndex: number,method:any=''): void {
    const inputValue = method=='paste'?event: event.target.value;
    // console.log( typeof inputValue);
    if (!(inputValue >= 0) || !(inputValue < 10) ) {
      this.otpForm.get(this.otpValueGroup[currentIndex])?.setValue('');
      return;      
    }
    if (inputValue && (currentIndex < (this.otpValueGroup.length - 1))) {
      const nextInput = this.otpValueGroup[currentIndex + 1];
      this.setFocus(nextInput);
    }
  }

  onPasteHandler(data:any){
    data=data?.trim();
    if(data<=999999){
      let splitData=data.split('')
        for(let i=0;i<splitData.length;i++){
          this.otpForm.controls[this.otpValueGroup[i]].patchValue(splitData[i]);
        }
        this.onInput(splitData[splitData.length-1],splitData.length-2,'paste') 
    }
    
  }

  onDelete(event: any, currentIndex: number): void {
    if (!event.target.value && currentIndex > 0) {
      const previousInput = this.otpValueGroup[currentIndex - 1];
      this.setFocus(previousInput);
    }
  }

  setFocus(input: string) {
    if (input) {
      document.getElementById(input)?.focus();
    }
  }
  // updateMasking(format: '') {
  //   this.mask = format.replace(/#/g, '0');
  //   // this.mask = '0000-000-000';
  // }

  // when business select country
  // countrySelected() {
  //   if (this.signUpForm.value && this.signUpForm.value.country_id) {
  //     const currency: Array<any> = this.countryList.filter((item: any) => item.country_id == this.signUpForm.value.country_id);
  //     this.updateMasking(currency[0]['country_phone_format']);
  //     console.log(currency[0]['country_phone_format']);
  //     if (currency && currency.length) {
  //       if (currency[0]['currency']) {
  //         this.currencyList = currency[0].currency;
  //         this.signUpForm.patchValue({ currency_id: this.currencyList[0]['currency_id'] });
  //         if (this.currencyList.length === 1) {
  //           this.signUpForm.controls['currency_id'].disable();
  //         } else {
  //           this.signUpForm.controls['currency_id'].enable();
  //         }
  //         // this.doctor_mobile_pattern = currency[0].mobile_regex;
  //         // this.phone_length = currency[0].phone_length;
  //       }
  //       const index = this.countryList.findIndex((item: any) => item.country_id == this.signUpForm.value.country_id);
  //       // this.changeFlag(index);
  //     }
  //   }
  // }

  // when business change country code
  // countryCodeSelected() {
  //   if (this.signUpForm.value && this.signUpForm.controls['doctor_mobile_country_code']) {
  //     const currency = this.countryList.filter((item: any) => item.mobile_code == this.signUpForm.controls['doctor_mobile_country_code']);
  //     if (currency && currency.length) {
  //       if (currency[0]['currency']) {
  //         this.signUpForm.patchValue({doctor_mobile: ''});
  //         // this.doctor_mobile_pattern = currency[0].mobile_regex;
  //         // this.phone_length = currency[0].phone_length;
  //       }
  //       const index = this.countryList.findIndex((item: any) => item.doctor_mobile_country_code == this.signUpForm.controls['doctor_mobile_country_code']);
  //       // this.changeFlag(index);
  //     }
  //   }
  // }

  // validate email first whether email exist or not
  async submitForm() {
    // if (this.signUpForm.invalid) {
    //   this.signUpForm.markAsDirty();
    //   this.signUpForm.markAllAsTouched();
    //   return;
    // }

    if (this.selectedStep == this.step.REGISTER) {
      if (!(this.signUpForm.controls['doctor_email'].value + '').trim() || this.signUpForm.get('doctor_email')?.invalid) {
        this._shared.customPopups('Please enter valid email', 1);
        return;
      }
      if (!(this.signUpForm.controls['doctor_name'].value + '').trim() || this.signUpForm.get('doctor_name')?.invalid) {
        this._shared.customPopups('Please enter valid doctor name', 1);
        return;
      }

      if (!(this.signUpForm.controls['doctor_mobile'].value + '').trim() || this.signUpForm.get('doctor_mobile')?.invalid) {
        this._shared.customPopups('Please enter valid doctor mobile', 1);
        return;
      }
      
      if (this.signUpForm.controls['doctor_password'].errors?.['cannotContainSpace'] ){
        // this._shared.customPopups('Password does not meet the required criteria.', 2);
        return
      }  
      if (this.signUpForm.value.doctor_password.length < 8) {
        this._shared.customPopups('Password does not meet the required criteria.', 2);
        return;
      }
      
      if (!/[A-Z]/.test(this.signUpForm.value.doctor_password)) {
        this._shared.customPopups('Password does not meet the required criteria.', 2);
        return;
      }
      
      if (!/[a-z]/.test(this.signUpForm.value.doctor_password)) {
        this._shared.customPopups('Password does not meet the required criteria.', 2);
        return;
      }
      
      if (!/[0-9]/.test(this.signUpForm.value.doctor_password)) {
        this._shared.customPopups('Password does not meet the required criteria.', 2);
        return;
      }
      
      if (!/[^A-Za-z0-9]/.test(this.signUpForm.value.doctor_password)) {
        this._shared.customPopups('Password does not meet the required criteria.', 2);
        return;
      }

     
      // Consent is collected in the legal documents modal. The first pass
      // through opens it and stops here; accepting re-enters this method with
      // TnC set, and the flow continues to OTP.
      if (!this.signUpForm.controls['TnC'].value) {
        this.openLegalDocuments(true);
        return;
      }

      this._loader.showLoader();
      const captcha = await this._captcha.getCaptchaToken();
       const mobileNumber = this.signUpForm.controls['doctor_mobile'].value + '';
      this.last4Number = mobileNumber.substring(mobileNumber.length - 4, mobileNumber.length);
      // console.log('Captcha token:', token);
      const data: {
        doctor_email: string,
        doctor_name: string,
        captcha: string,
        referral_code?: string,
        doctor_mobile: string,
        doctor_mobile_country_code:string,
        phone_verify:boolean

      } = {
        phone_verify:true,
        doctor_email: this.signUpForm.controls['doctor_email'].value + '',
        doctor_name: this.signUpForm.controls['doctor_name'].value,
        captcha,
        doctor_mobile: mobileNumber,
         doctor_mobile_country_code: this.country_data?.mobile_code || this.country_data?.country_phone_code || ''
      };
      if (this.referral_code) {
        data['referral_code'] = this.referral_code;
      }
      this.apiSer.api(data, 'auth/send_otp_number_v2').subscribe({
        next: data => {
          if (data.is_error == 0) {
            if (data.otp_id) {
              this.otp_id = data.otp_id;
            }
            this.selectedStep = this.step.VERIFY_OTP;
            if (data.otp && !environment.production) {
              this._shared.customPopups(data.otp, 0);
            }
            this.startCountdown();
            this.countdown = 180
            this.otpForm.reset();
          } else {
            // The signup did not go through, so the consent that was collected
            // for it no longer stands. Reset it, otherwise a second attempt
            // would skip the modal and submit without the user re-agreeing.
            this.resetConsent();
            this.signUpForm.markAsDirty();
            this.signUpForm.markAsTouched();
            window.scroll(0, 0);
          }
        },
        error: () => {
          this.resetConsent();
        }
      })
      return;
    }

   const mobileNumber = this.signUpForm.controls['doctor_mobile'].value || '';
const data: UserInfoType  = {
  doctor_name: this.signUpForm.controls['doctor_name'].value || '',
  doctor_email: this.signUpForm.controls['doctor_email'].value || '',
  doctor_password: this._shared.crypto(this.signUpForm.controls['doctor_password'].value || ''),
  doctor_mobile: mobileNumber,
  doctor_mobile_country_code: this.country_data?.mobile_code || this.country_data?.country_phone_code || '+1',
  country_id: this.counCurData.country_id,
  currency_id: this.counCurData.currency_id,
  doctor_image: undefined
};

// The consent record is not part of the register payload — it is uploaded
// separately once the account exists and has an id. See uploadConsent().

    if(data.doctor_name && data.doctor_email && data.doctor_password){
      this.new_case=true;
    }
    console.log(data);
    this.mainService.registerUser(data, doctorId => this.uploadConsent(doctorId));
  }

  verifyOtp() {
    if (this.otpForm.invalid) {
      this.otpForm.markAsDirty();
      this.otpForm.markAllAsTouched();
      return;
    }
    let data;
    let value = '';
    this.otpValueGroup.filter(input => value += this.otpForm.value[input]);
    data = {
      otp: value,
      otp_id: this.otp_id,
      doctor_mobile: this.signUpForm.controls['doctor_mobile'].value,
      doctor_mobile_country_code: this.country_data?.mobile_code || this.country_data?.country_phone_code || ''
    };
    this.apiSer.api(data, 'auth/verify_otp_number_v2').subscribe((data) => {

      if (data.is_error == 0) {
        // this.selectedStep = this.step.COMPLETE_PROFILE;
        // this.router.navigate(['business-info']);
        // this.submitForm();
        //    this.getBankStatus();
        this.selectedStep = this.step.COMPLETE_PROFILE;
     this.startLoader();
      } else {
        this.otpForm.markAsDirty();
        this.otpForm.markAsTouched();
        window.scroll(0, 0);
      }
    });
  }



startLoader() {
  this.idverification = 0; 
  this.loaderComplete = false;
   this.selectedStep = this.step.COMPLETE_PROFILE;
  this.loaderInterval = setInterval(() => {
    if (this.idverification < 100) {
      this.idverification += 1; 
    } else {
      clearInterval(this.loaderInterval);
     this.loaderComplete = true;
      this.submitForm();
 
       setTimeout(() => {
        this.router.navigate(['business-info']);
      },1500);
    }
  },50); 
}


  /**
   * Stores the consent record against the newly created account. Runs after
   * registration because the id it is filed under only exists at that point.
   * A failure here must not disrupt signup — the account is already created
   * and the user is on their way — so it is reported but not surfaced.
   */
  private async uploadConsent(doctorId: number): Promise<void> {
    if (!this.consentCapture || !doctorId) {
      return;
    }
    const capture = this.consentCapture;
    const formData = new FormData();
    // Sent as a file rather than a base64 string: the data URL inflates the
    // payload by a third and the panel uploads images this way everywhere else.
    const file = await this._shared.base64ToBlob(capture.image);
    formData.append('doctor_consent', file, `consent-${doctorId}.jpg`);
    formData.append('doctor_id', String(doctorId));
    formData.append('captured_at', capture.captured_at);

    this.apiSer.uploadApi(formData, 'auth/upload_doctor_consent').subscribe({
      next: response => {
        const body = response?.body;
        if (body && body.is_error) {
          console.error('[consent] upload rejected', body.original_text || body);
        }
      },
      error: err => console.error('[consent] upload failed', err?.status, err?.message || err)
    });
  }

  /**
   * Returns to the signup form from the OTP step. The consent is cleared on
   * the way back: the details it was given against can now be edited, and the
   * captured record shows the old ones, so it has to be granted again.
   */
  backToSignUp(): void {
    this.selectedStep = this.step.REGISTER;
    this.resetConsent();
  }

  /**
   * Clears a previously given consent and the record captured with it, so the
   * legal documents must be reviewed and accepted again before the next
   * submission.
   */
  private resetConsent(): void {
    this.signUpForm.controls['TnC'].setValue(false);
    this.consentCapture = null;
    this.consentedName = '';
  }

  /**
   * Presents the Privacy Policy and Terms & Conditions and collects the
   * user's acceptance. Nothing is submitted until they accept.
   */
  /**
   * @param continueSubmit true when the submit flow opened this and should
   * carry on once accepted. Opening the documents from the notice is just a
   * read-through, so accepting there records the consent without pushing an
   * unfilled form through validation.
   */
  openLegalDocuments(continueSubmit = false) {
    this.bsModalRef = this.modalService.show(LegalDocumentsComponent, {
      initialState: {
        businessName: this.signUpForm.controls['doctor_name'].value || ''
      },
      class: 'modal-dialog-centered modal-lg legal-modal-wrapper',
      ignoreBackdropClick: true,
      keyboard: false
    });

    const modal = this.bsModalRef.content as LegalDocumentsComponent;

    modal.onAccept.subscribe(async (dismiss: () => void) => {
      // Capture the screen exactly as the user sees it: the branded panel,
      // the dimmed signup form and the open dialog on top. document.body is
      // marked keep-size for the duration, so it is photographed at viewport
      // height instead of being expanded to the full page/document length.
      const agreed = document.body;
      try {
        if (agreed) {
          this.consentCapture = await this._consent.capture(agreed, { viewport: true });
        }
      } finally {
        // Always dismiss, even if the capture failed — a failed record must
        // not strand the user in the dialog.
        dismiss();
      }
      this.signUpForm.controls['TnC'].setValue(true);
      this.consentedName = (this.signUpForm.controls['doctor_name'].value ?? '').trim();
      if (continueSubmit) {
        this.submitForm();
      }
    });

    modal.onDecline.subscribe(() => {
      this.signUpForm.controls['TnC'].setValue(false);
    });
  }

  showReferralModal() {
    const initialState = {
    };
    this.bsModalRef = this.modalService.show(ReferralCodeComponent, {
      initialState,
      class: 'modal-dialog-centered bs-modal-wrapper'
    });

    this.bsModalRef.content.onReferralCode.subscribe((referralCode: string) => {
      console.log('Referral code received:', referralCode);
      this.referral_code = referralCode;
    });
  }
  RemoveReferralCode() {
    this.referral_code = ''
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  startCountdown(): void {

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.countdownInterval); 
      }
    }, 1000); 
  }
  async sendOtp(){
     const mobileNumber = this.signUpForm.controls['doctor_mobile'].value + '';
      this.last4Number = mobileNumber.substring(mobileNumber.length - 4, mobileNumber.length);
    const captcha = await this._captcha.getCaptchaToken();
    let data = {
      phone_verify:true,
      captcha : captcha,
      doctor_email: this.signUpForm.controls['doctor_email'].value,
      doctor_mobile: mobileNumber,
      doctor_mobile_country_code: this.country_data?.mobile_code || this.country_data?.country_phone_code || ''
    }

    this.apiSer.api(data, 'auth/send_otp_number_v2').subscribe({
      next:(response)=>{
        if (response && !response.is_error) {
          this.selectedStep = this.step.VERIFY_OTP;
          this.otp_id = response.otp_id;
          if (response.otp && !this.environment.production) {
            this._shared.customPopups(response.otp, 0);
          }
          this.startCountdown();
        }
      }
    })

   console.log(this.signUpForm,"send otp successfully");
   
  }

  renewOtp(): void {
    this.sendOtp();
    this.countdown = 180;     
  }

  /**
   * Bound to the blur of both the name and email fields, so it runs whenever
   * either loses focus. setValue() emits valueChanges even when the value is
   * unchanged, and the doctor_name watcher treats that as an edit and clears an
   * acceptance already given — so tabbing from Name to Email after accepting
   * would silently reopen the legal documents. Only write when trimming
   * actually changes something.
   */
  trimData(){
    const name = this.signUpForm.controls['doctor_name'].value ?? '';
    if (name !== name.trim()) {
      this.signUpForm.controls['doctor_name'].setValue(name.trim());
    }
    const email = this.signUpForm.controls['doctor_email'].value ?? '';
    if (email !== email.trim()) {
      this.signUpForm.controls['doctor_email'].setValue(email.trim());
    }
  }
}

export interface userInfo {
  doctor_name: string;
  doctor_email: string;
  doctor_password?: string;
  doctor_mobile: string;
  doctor_mobile_country_code?: string;
  country_id?: number;
  currency_id?: number;
  doctor_image?: any;
}
